import {IconButton, Stack, TableCell, TableRow, useTheme} from "@mui/material";
import {userOptions} from "../../../user";
import Box from "@mui/material/Box";
import {DealTypesMapping} from "../../../dictionaries";
import {getDealStatusChips} from "../../../domains/common/components/Chips";
import React, {useContext} from "react";
import {DealListActionMenu} from "./actionMenu";
import {Notifications, PushPin, PushPinOutlined} from "@mui/icons-material";
import {pinDealAPI, unpinDealAPI} from "../dealsApi";
import {DealsPageContext} from "../index";

const rrData = (item) => {
  if (!item)
    return '';
  const {openNotify} = useContext(DealsPageContext);

  const copyOnClick = (text) => {
    navigator.clipboard.writeText(text)

    openNotify({
      msg: "Скопировано",
      duration: 1200,
      type: 'success',
      positionH: 'right',
    })
  }

  return (
    <>
      {item.kuvdNumber ?
        <div><a onClick={() => copyOnClick(item.kuvdNumber)} className="copyOnClickText">{item.kuvdNumber}</a>
        </div> : void 0}
      {item.requestNumber ? <div>{item.requestNumber}</div> : void 0}
      {item.uin ?
        <div>УИН: <a onClick={() => copyOnClick(item.uin)} className="copyOnClickText">{item.uin}</a></div> : void 0}
    </>
  )
}

export const DealsTableRows = () => {
  const theme = useTheme();
  const {dealsList, pinDeal, unpinDeal, openEventsDrawer} = useContext(DealsPageContext);

  return (
    dealsList?.map((item) => {
      const ref = `/deal?id=${item.id}`

      return (
        <TableRow item xs={10} container spacing={0} hover={true}
                  sx={{borderBottomColor: theme.palette.border.default}}>
          <TableCell item sx={{
            maxWidth: 35,
            color: theme.palette.text.table.default,
            borderBottomColor: 'inherit'
          }}
                     component='a'
                     href={ref}
                     underline="none"
                     target={userOptions.openLinkCurrentTab ? "" : "_blank"}>{item.id}</TableCell>
          <TableCell item sx={{
            maxWidth: 35,
            color: theme.palette.text.table.default,
            borderBottomColor: 'inherit',
            whiteSpace: 'nowrap',
            paddingLeft: '4px',
            paddingRight: '4px'
          }}
                     component='a'
                     href={ref}
                     underline="none"
                     target={userOptions.openLinkCurrentTab ? "" : "_blank"}>
            <Box sx={{ display: 'inline-block', mr: 1, mt: '1px' }}>
              <NotificationDealComponent deal={item}/>
            </Box>
            <Box sx={{ display: 'inline-block', verticalAlign: 'top' }}>
              <DealWithMortgageIcon deal={item} />
            </Box>
          </TableCell>
          <TableCell item sx={{
            maxWidth: 90,
            color: theme.palette.text.table.default,
            borderBottomColor: 'inherit'
          }} component='a'
                     href={ref} underline="none"
                     target={userOptions.openLinkCurrentTab ? "" : "_blank"}>{item.createdAt}</TableCell>
          <TableCell item sx={{
            maxWidth: 380,
            pl: '0px',
            color: theme.palette.text.table.default,
            borderBottomColor: 'inherit'
          }}
                     component='a'
                     href={ref} underline="none"
                     target={userOptions.openLinkCurrentTab ? "" : "_blank"}>{item.title}</TableCell>
          <TableCell item sx={{
            maxWidth: 150,
            pl: '0px',
            color: theme.palette.text.table.default,
            borderBottomColor: 'inherit'
          }}
                     component='a'
                     href={ref} underline="none"
                     target={userOptions.openLinkCurrentTab ? "" : "_blank"}>{DealTypesMapping[item.type]}</TableCell>
          <TableCell item component='a' href={ref}
                     sx={{color: theme.palette.text.table.default, borderBottomColor: 'inherit'}}
                     underline="none"
                     target={userOptions.openLinkCurrentTab ? "" : "_blank"}>{item.fio}</TableCell>
          <TableCell item target={userOptions.openLinkCurrentTab ? "" : "_blank"}
                     sx={{
                       whiteSpace: "pre-wrap",
                       pl: '0px',
                       color: theme.palette.text.table.default,
                       borderBottomColor: 'inherit'
                     }}>{rrData(item)}</TableCell>
          <TableCell item
                     sx={{maxWidth: 250, borderBottomColor: 'inherit', cursor: "pointer"}}
                     className='listItem'>
            <Stack spacing={1}
                   onClick={() => openEventsDrawer(item.id)}>{getDealStatusChips(item?.status)}</Stack>
          </TableCell>
          <TableCell item sx={{maxWidth: '25px', p: '0px', borderBottomColor: 'inherit'}}>
            {item.pinned ? <UnpinButton dealId={item.id} onClick={unpinDeal}/> :
              <PinButton dealId={item.id} onClick={pinDeal}/>}
          </TableCell>
          <TableCell item sx={{maxWidth: '25px', pl: '0px', borderBottomColor: 'inherit'}} className='listItem'>
            <DealListActionMenu dealId={item.id}
                                status={item.status}/>
          </TableCell>
        </TableRow>
      )
    })
  )
}


function PinButton({dealId, onClick}) {
  const handleClick = () => {
    pinDealAPI(dealId)

    onClick ? onClick(dealId) : void 0;
  };

  const theme = useTheme();

  return (
    <IconButton onClick={handleClick}>
      <PushPinOutlined sx={{fontSize: '18px', color: theme.palette.icon.secondary}}/>
    </IconButton>
  );
}

function UnpinButton({dealId, onClick}) {
  const handleClick = () => {
    unpinDealAPI(dealId);

    onClick ? onClick(dealId) : void 0;
  };

  const theme = useTheme();

  return (
    <IconButton onClick={handleClick}>
      <PushPin sx={{fontSize: '18px', color: theme.palette.icon.default}}/>
    </IconButton>
  );
}


/**
 * Компонент если сделка завершена и не просмотрена
 * @param deal
 * @returns {Element}
 * @constructor
 */
export function NotificationDealComponent({deal}) {
  const theme = useTheme();

  if(deal?.status === 'dealCompleted' && !deal?.viewedAt)
    return <Notifications sx={{fontSize: '20px', color: theme.palette.info.main}} />
}

/**
 * Компонент возвращает иконку ипотеки если в сделки есть ипотека
 * @param deal
 * @returns {Element}
 * @constructor
 */
export function DealWithMortgageIcon({deal}) {
  const theme = useTheme();

  if(deal?.dealWithMortgage)
    return <div style={{fontSize: '18px', color: theme.palette.text.success}}>&#8381;</div>
}